import React, { useState, createContext, useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase-config/firebase';
import { getDocs, collection } from 'firebase/firestore';

export const DataContext = createContext()

const ContextProvider = ({children}) => {
  const [propertiesDeatils, setPropertiesDetails] = useState([])
  const [list, setList] = useState()
  const [properties, setProperties] = useState(propertiesDeatils)
  const [selectedProperty, setSelectedProperty] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [whatsappMessage, setWhatsappMessage] = useState("")

  const navigate = useNavigate()


  const tour = (e, property) => {
    e.stopPropagation()
    setOpenModal(true)

    const whatsappText = `Hi, I'm interested in this property: ${property.title}, ${property.location.city}, ${property.location.state}. Price: #${property.price} million. I will love to schedule an inspection.`;
    setWhatsappMessage(whatsappText)
  }

  const handleSendToWhatsApp = () => {
    const phoneNumber = +2348156959983
      const whatsappUrl = `https://api.whatsapp.com/send?phone=${encodeURIComponent(phoneNumber)}&text=${encodeURIComponent(
        whatsappMessage
      )}`;

    window.open(whatsappUrl, '_blank');
    setOpenModal(false)
  }

  const getPropertyData = (property) => {
    setList(property)
    navigate("/property-details")
  }

  const ref = collection(db, "propertiesDetails")

  const getData = async () => {
    try{
      const data = await getDocs(ref)
      setPropertiesDetails(data.docs.map(doc => {
        return {
          ...doc.data(),
          id: doc.id
        }
      }))
    }
    catch(err){
      console.log(err.message)
    }
  }

  const memorizedPropertiesDetails = useMemo(() => {
    return propertiesDeatils
  }, [propertiesDeatils])

  useEffect(() => {
    if (list) {
      return;
    }
    
    getData()

    return () => getData()
  }, [])

  useEffect(() => {
    const fetchPropertiesData = async () => {
      try {
        const propertyData = await getDocs(ref);
        setProperties(propertyData.docs.map(doc => ({ ...doc.data(), id: doc.id })));
      } catch (error) {
        console.log(error.message);
      }
    };

    fetchPropertiesData();

    return () => fetchPropertiesData()
  }, []);

  return (
    <DataContext.Provider 
    value={{
        selectedProperty,
        setSelectedProperty,
        navigate,
        db,
        collection,
        getDocs,
        ref,
        list,
        setList,
        getPropertyData,
        memorizedPropertiesDetails,
        setPropertiesDetails,
        properties,
        setProperties,
        getData,
        openModal,
        setOpenModal,
        setWhatsappMessage,
        whatsappMessage,
        tour,
        handleSendToWhatsApp
      }}>
      {children}
    </DataContext.Provider>
  )
}

export default ContextProvider
